// ** admin routes **
import AppRoutes from './menu';
import AreaRoutes from './area';
import IllnessRoutes from './illness';
import DisaasesRoutes from './illness';
import CurrencyRoutes from './currency';
import MedicinesRoutes from './medicines';
import PolicyholdersRoutes from './insurer';
import InsurancePrograms from './insurance-programs';
import MedicalServiceRoutes from './medical-service';
import InsuranceCompanies from './insurance-companies';
import MedicalInstitutions from './medicalInstitutions';

// ** Merge Routes
const AllRoutes = [
  ...AppRoutes,
  ...AreaRoutes,
  ...IllnessRoutes,
  ...CurrencyRoutes,
  ...DisaasesRoutes,
  ...MedicinesRoutes,
  ...InsurancePrograms,
  ...InsuranceCompanies,
  ...MedicalInstitutions,
  ...PolicyholdersRoutes,
  ...MedicalServiceRoutes,
];

export { AllRoutes };
